import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateIdentificationDocumentQueries } from "web_myplann/Api/Client/invalidateIdentificationDocumentQueries";
import {
	type CreateIdentificationDocumentRequestDTO,
	postClientIdentificationDocumentsV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useCreateIdentificationDocumentMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(data: CreateIdentificationDocumentRequestDTO) =>
				postClientIdentificationDocumentsV2(data),
		),
		onSuccess: () => {
			invalidateIdentificationDocumentQueries(queryClient);
		},
	});
};
